import queryString from "query-string";
import { OFFER_TYPES } from "../constants/offerTypes";
import { decamelizeKeys } from "humps";
import { mergeLimitsWithFilter } from "./limits";

const dataToPortalQueryString = (limits, filter, offerType = null) => {
  let params = mergeLimitsWithFilter(limits, filter, true);

  if (offerType) {
    if (offerType === OFFER_TYPES.phoneOffer) {
      params.offerType = "phone_offer";
    } else if (offerType === OFFER_TYPES.simOnly) {
      params.brandId = [];
      params.isBusiness = false;
      params.isSimOnly = true;
      params.offerType = "proposition";
      params.phoneCategoryId = [];
      params.phoneId = [];
      params.phoneOperatingSystemId = [];
      params.phoneVariantId = [];
    } else {
      params.isBusiness = false;
      params.isSimOnly = false;
      params.offerType = "proposition";
    }
  }

  params = decamelizeKeys(params);

  return queryString.stringify(params, { arrayFormat: "bracket" });
};

export default dataToPortalQueryString;
